import { Tooltip } from '../../../tooltip/Tooltip';

export function CreatePipelineWizardHeaderLeft({ pipelineName }: { pipelineName?: string }) {
  const name = pipelineName || 'Create Pipeline';

  return (
    <Tooltip enableOnTextOverflow title={name} dataId='pipeline-name'>
      <span
        data-id='pipeline-name'
        className='text-subheading-2 text-ellipsis'
        style={{ width: 250 }}
      >
        {name}
      </span>
    </Tooltip>
  );
}
